export default {
    daySelector: {
        day: 'Dan',
    },
}
